import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ptBRCore from './core/globalization/pt-BR.json';
import enUSCore from './core/globalization/en-US.json';
import ptBRAccount from './modules/account/business/core/globalization/pt-BR.json';
import enUSAccount from './modules/account/business/core/globalization/en-US.json';
import ptBRAdmDashboard from './modules/dashboard/business/core/globalization/pt-BR.json';
import enUSAdmDashboard from './modules/dashboard/business/core/globalization/en-US.json';
import ptBRAdmPanel from './modules/adm-panel/business/core/globalization/pt-BR.json';
import enUSAdmPanel from './modules/adm-panel/business/core/globalization/en-US.json';
import ptBRProduct from './modules/product/business/core/globalization/pt-BR.json';
import enUSProduct from './modules/product/business/core/globalization/en-US.json';
import ptBRReports from './modules/reports/business/core/globalization/pt-BR.json';
import enUSReports from './modules/reports/business/core/globalization/en-US.json';

const getBrowserLanguage = () => {
    const language = navigator.language || navigator.userLanguage;
    return language.split('-')[0];
};

i18n
    .use(initReactI18next)
    .init({
        resources: {
            pt: {
                account: ptBRAccount,
                admDashboard: ptBRAdmDashboard,
                admPanel: ptBRAdmPanel,
                core: ptBRCore,
                product: ptBRProduct,
                reports: ptBRReports,
            },
            en: {
                account: enUSAccount,
                admDashboard: enUSAdmDashboard,
                admPanel: enUSAdmPanel,
                core: enUSCore,
                product: enUSProduct,
                reports: enUSReports,
            },
        },
        lng: getBrowserLanguage(),
        fallbackLng: 'pt',
        interpolation: {
            escapeValue: false,
        },
        ns: ['reports'],
        defaultNS: 'reports',
        backend: {
            loadPath: '/src/modules/{{ns}}/business/core/globalization/{{lng}}.json',
        },
        react: {
            useSuspense: false,
        },
    });

export default i18n;
